import NEW_BOOKING_STEPS from 'constants/newBookingSteps';

const PRIVATE_REFERRAL = Object.freeze({
    ownerPetDetails: NEW_BOOKING_STEPS.ownerPetDetails,
    confirmation: NEW_BOOKING_STEPS.confirmation
});

export default PRIVATE_REFERRAL;
